import { useState, useEffect } from 'react';
import { useAuth, useModules, useToast } from '../hooks';
import { profileService } from '../services';
import {
  ModuleGrid,
  QuickStats,
  Announcements,
  LoadingSpinner
} from '../components';

const Dashboard = () => {
  const { user } = useAuth();
  const { modules, isLoading, openModule } = useModules();
  const { showError } = useToast();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const loadPreferences = async () => {
      try {
        const prefs = await profileService.getPreferences();
        if (prefs?.favoriteModules) {
          setFavorites(prefs.favoriteModules);
        }
      } catch (err) {
        console.error('Failed to load preferences:', err);
      }
    };

    loadPreferences();
  }, []);

  const handleToggleFavorite = async (moduleId) => {
    const newFavorites = favorites.includes(moduleId)
      ? favorites.filter(id => id !== moduleId)
      : [...favorites, moduleId];

    setFavorites(newFavorites);

    try {
      await profileService.updatePreferences({ favoriteModules: newFavorites });
    } catch (err) {
      showError('Failed to save favorite');
      setFavorites(favorites);
    }
  };

  const handleOpenModule = (module) => {
    openModule(module);
  };

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <LoadingSpinner size="lg" />
        <p>Loading your workspace...</p>
      </div>
    );
  }

  const favoriteModules = modules.filter(m => favorites.includes(m.id));
  const otherModules = modules.filter(m => !favorites.includes(m.id));

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="welcome-section">
          <h1>Welcome back, {user?.firstName}</h1>
          <p>Access your applications and manage your work</p>
        </div>
        <QuickStats />
      </div>

      <div className="dashboard-content">
        <div className="modules-section">
          {favoriteModules.length > 0 && (
            <div className="module-group">
              <h2 className="group-title">★ Favorites</h2>
              <ModuleGrid
                modules={favoriteModules}
                favorites={favorites}
                onToggleFavorite={handleToggleFavorite}
                onOpenModule={handleOpenModule}
              />
            </div>
          )}

          <div className="module-group">
            <h2 className="group-title">Applications</h2>
            <ModuleGrid
              modules={otherModules}
              favorites={favorites}
              onToggleFavorite={handleToggleFavorite}
              onOpenModule={handleOpenModule}
            />
          </div>
        </div>

        <aside className="dashboard-sidebar">
          <Announcements />
        </aside>
      </div>
    </div>
  );
};

export default Dashboard;
